import { memo } from "react"

import { Label } from "@/components/ui/label"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"

interface IRecurrenceUpdateChoiceProps {
  value: "current" | "next" | "all" | null
  onChange: (value: "current" | "next" | "all") => void
}

/**
 * Recurrence update choice selector for editing recurring transactions
 * Allows user to choose: update current, current+future, or all occurrences
 */
export const RecurrenceUpdateChoice = memo(function RecurrenceUpdateChoice({
  value,
  onChange,
}: IRecurrenceUpdateChoiceProps) {
  return (
    <div className="border rounded-lg p-4 space-y-3">
      <Label>Esta transação se repete em outras datas.</Label>
      <RadioGroup
        value={value || ""}
        onValueChange={(newValue) =>
          onChange(newValue as "current" | "next" | "all")
        }
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="current" id="current" />
          <Label htmlFor="current">Apenas este lançamento</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="next" id="next" />
          <Label htmlFor="next">Este e os próximos</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="all" id="all" />
          <Label htmlFor="all">Todos da recorrência</Label>
        </div>
      </RadioGroup>
    </div>
  )
})

RecurrenceUpdateChoice.displayName = "RecurrenceUpdateChoice"
